/**
 * Página de alta y edición de un rango de precios
 */
import React, { useContext } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Box, Alert, Button, CircularProgress, Stack } from "@mui/material";

import { StateContext } from "../../../components/context/StateProvider";
import Toasts from "../../../components/notificacion/Toasts";
import { BOTON_SECUNDARIO_SX } from "../../../components/ui/buttonStyles";
import { RangoForm } from "../components";
import { useRangoFormData } from "../hooks";

// DECISION: página delgada, igual que NuevaPeticion.js. Toda la validación y
// la llamada a create/update viven en RangoForm; la resolución de datos
// (transportistas + rango a editar, sin GET por id, ver docs/api/rangos.md)
// vive en useRangoFormData. Aquí solo se reacciona a onSave/onError/onCancel
// con navegación y toasts.
// Rutas que consume esta página (pendientes de registrar en routes.js, TASK-014):
//   /rangos/nuevo       -> alta
//   /rangos/:id/editar  -> edición, recibe la fila en location.state.rango
const RangoFormPage = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { state, updateState } = useContext(StateContext);
    const esEdicion = Boolean(id);

    const { transportistas, rango, cargando, error } = useRangoFormData(
        id,
        location.state?.rango ?? null
    );

    const volverAlListado = () => navigate("/rangos");

    const handleSave = (_rangoGuardado) => {
        const mensaje = esEdicion ? "Rango actualizado correctamente" : "Rango creado correctamente";
        updateState({ toasts: [...state.toasts, Toasts.generateToast(mensaje, "success")] });
        volverAlListado();
    };

    const handleError = (mensajeError) => {
        updateState({ toasts: [...state.toasts, Toasts.generateToast(mensajeError, "error")] });
    };

    if (cargando) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                <CircularProgress size={40} sx={{ color: "#cc071e" }} />
            </Box>
        );
    }

    if (error) {
        return (
            <Stack spacing={2} sx={{ width: "100%" }}>
                <Alert severity="error">{error}</Alert>
                <Button variant="outlined" onClick={volverAlListado} sx={{ ...BOTON_SECUNDARIO_SX, alignSelf: "flex-start" }}>
                    Volver al listado
                </Button>
            </Stack>
        );
    }

    return (
        <Box id="rango-form-page" sx={{ width: "100%" }}>
            <RangoForm
                rango={rango}
                transportistas={transportistas}
                onSave={handleSave}
                onError={handleError}
                onCancel={volverAlListado}
            />
        </Box>
    );
};

export default RangoFormPage;
